import { TanstackDevtools } from "@tanstack/react-devtools";
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import { TanStackRouterDevtoolsPanel } from "@tanstack/react-router-devtools";

import TanStackQueryDevtools from "../integrations/tanstack-query/devtools";
import StoreDevtools from "../integrations/tanstack-store/store-devtools";

import type { IAuthContext } from "@/providers/AuthProvider";
import type { QueryClient } from "@tanstack/react-query";

import { DirectionProvider } from "@/components/ui/direction";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import useRTL from "@/hooks/useRTL";

interface IRouterContext {
  queryClient: QueryClient;
  auth: IAuthContext;
}

export const Route = createRootRouteWithContext<IRouterContext>()({
  component: RootLayout,
});

function RootLayout() {
  const isRTL = useRTL();

  return (
    <DirectionProvider dir={isRTL ? "rtl" : "ltr"}>
      <TooltipProvider>
        <main className="min-h-screen w-full bg-background text-foreground flex flex-col">
          <Outlet />
        </main>

        {process.env.NODE_ENV === "development" && (
          <TanstackDevtools
            config={{
              position: "bottom-right",
            }}
            plugins={[
              {
                name: "Tanstack Router",
                render: <TanStackRouterDevtoolsPanel />,
              },
              StoreDevtools,
              TanStackQueryDevtools,
            ]}
          />
        )}

        <Toaster position={isRTL ? "bottom-left" : "bottom-right"} />
      </TooltipProvider>
    </DirectionProvider>
  );
}
